import { useEffect, useState } from "react";
import { AuthInterceptor } from "../../services/AuthInterceptor.Service";
import Spinnerr from "../Commaon/Spinner";
import Toaster from "../Commaon/Toaster";
import { CgPen, CgTrash } from "react-icons/cg";
import { Modal } from "react-bootstrap";
import CustomModal from "../Commaon/CustomModal";

const GroupsList = () => {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState(null);

  // pagination states
  const [pageNo, setPageNo] = useState(1);
  const [limit, setLimit] = useState(10);

  // edit states
  const [editModel, setEditModel] = useState(false);
  const [addSlots, setAddSlots] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editGroupName, setEditGroupName] = useState("");
  const [addGroupName, setAddGroupName] = useState("");
  const [editGroupType, setEditGroupType] = useState("");
  const [addGroupType, setAddGroupType] = useState("");
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);

  const getSlots = async () => {
    setLoading(true);
    try {
      const response = await AuthInterceptor(`/admin/slot-group`, {
        method: "GET",
      });
      const data = response.data;
      if (data.s === 200) setSlots(data.r || []);
    } catch (err) {
      console.error("Failed to fetch slots:", err);
      setSnack({
        notification: { message: "Error fetching slots", type: "error" },
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSlots();
  }, []);

  const toggleStatus = async (slot) => {
    try {
      setLoading(true);
      const response = await AuthInterceptor(`/admin/slot-group/${slot._id}/toggle`, {
        method: "PATCH",
        body: JSON.stringify({ isActive: !slot.isActive }),
      });
      const data = response.data;

      if (data.s === 200) {
        setSlots((prev) =>
          prev.map((s) =>
            s._id === slot._id ? { ...s, isActive: !s.isActive } : s
          )
        );
        setSnack({
          notification: {
            message: `Slot ${
              slot.isActive ? "deactivated" : "activated"
            } successfully`,
            type: "success",
          },
        });
      }
    } catch (err) {
      console.error("Error toggling status:", err);
      setSnack({
        notification: { message: "Error updating status", type: "error" },
      });
    } finally {
      setLoading(false);
    }
  };

  const editSlot = async (slot) => {
    try {
      setLoading(true);
      const response = await AuthInterceptor(`/admin/slot-group/${slot._id}`, {
        method: "GET",
      });
      const data = response?.data?.r || slot;
      setEditId(slot._id);
      setEditGroupName(data.groupName);
      setEditGroupType(data.groupType);
      setEditModel(true);
    } catch (err) {
      setEditId(slot._id);
      setEditGroupName(slot.groupName);
      setEditGroupType(slot.groupType);
      setEditModel(true);
    } finally {
      setLoading(false);
    }
  };

  const deleteSlot = async (id) => {
    setConfirmDeleteId(id);
    setShowDeleteConfirm(true);
  }

  // add slot states
  const handleAddSlot = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await AuthInterceptor(`/admin/slot-group`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          groupName: addGroupName,
          groupType: addGroupType,
        }),
      });

      const data = response.data;
      if (data.s === 201) {
        setSlots((prev) => [...prev, data.r]);
        setSnack({
          notification: {
            message: "Slot Added successfully",
            type: "success",
          },
        });
      }
    } catch (err) {
      console.error("Error adding slot:", err);
      setSnack({
        notification: { message: "Error adding slot", type: "error" },
      });
    } finally {
      setLoading(false);
      setAddSlots(false);
      setAddGroupName("");
      setAddGroupType("");
    }
  };

  const handleEditSlot = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await AuthInterceptor(`/admin/slot-group/${editId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          groupName: editGroupName,
          groupType: editGroupType,
        }),
      });

      const data = response.data;

      if (data.s === 200) {
        setSlots((prev) =>
          prev.map((s) =>
            s._id === editId
              ? { ...s, groupName: editGroupName, groupType: editGroupType }
              : s
          )
        );
        setSnack({
          notification: {
            message: "Slot updated successfully",
            type: "success",
          },
        });
      }
    } catch (err) {
      console.error("Error updating slot:", err);
      setSnack({
        notification: { message: "Error updating slot", type: "error" },
      });
    } finally {
      setLoading(false);
      setEditModel(false);
      setEditId(null);
    }
  };

  // pagination slice
  const startIndex = (pageNo - 1) * limit;
  const paginatedSlots = slots.slice(startIndex, startIndex + limit);

  return (
    <>
      {loading && <Spinnerr show={loading} />}
      {snack && (
        <Toaster
          notification={snack.notification}
          onClose={() => setSnack(null)}
        />
      )}

      <div className="card shadow-sm border-0 rounded-3 p-3">
        {/* Header + Page Size */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 mr-3 gap-3">
          <h2 className="mb-2 mb-md-0">Groups</h2>
          <div className="d-flex flex-row  align-items-center gap-3">
            <button
              className="btn btn-sm btn-outline-custom text-nowrap"
              onClick={() => setAddSlots(true)}
              disabled={loading}
            >
              Add Group
            </button>
            <select
              className="form-select form-select-sm"
              value={limit}
              onChange={(e) => {
                setPageNo(1);
                setLimit(Number(e.target.value));
              }}
            >
              {[5, 10, 20, 50].map((size) => (
                <option key={size} value={size}>
                  {size} per page
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Table */}
        <div>
          <table className="table table-hover align-middle text-center">
            <thead className="table-light">
              <tr>
                <th style={{ width: "10%" }}>Sr.</th>
                <th style={{ width: "30%" }}>Group Name</th>
                <th style={{ width: "30%" }}>Group Type</th>
                <th style={{ width: "20%" }}>Status</th>
                <th style={{ width: "10%" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedSlots.length > 0 ? (
                paginatedSlots.map((slot, idx) => (
                  <tr key={slot._id}>
                    <td>{startIndex + idx + 1}</td>
                    <td>{slot.groupName || "-"}</td>
                    <td>{slot.groupType || "-"}</td>
                    <td>
                      <span
                        role="button"
                        onClick={() => toggleStatus(slot)}
                        className={`badge ${
                          slot.isActive ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {slot.isActive ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td>
                      <div className="d-flex justify-content-center gap-3 fs-5">
                        <button
                        className="btn btn-sm btn-outline-custom"
                        onClick={() => editSlot(slot)}
                      >
                        <CgPen size={16} />
                      </button>
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => deleteSlot(slot._id)}
                      >
                        <CgTrash size={16} />
                      </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-muted py-4">
                    No slots found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="d-flex flex-wrap justify-content-between align-items-center m-3 gap-2">
          <button
            className="btn btn-outline-custom btn-sm"
            onClick={() => setPageNo((prev) => Math.max(prev - 1, 1))}
            disabled={pageNo === 1}
          >
            Prev
          </button>
          <span className="mx-2">
            Page {pageNo} of {Math.ceil(slots.length / limit) || 1}
          </span>
          <button
            className="btn btn-outline-custom btn-sm"
            onClick={() =>
              setPageNo((prev) =>
                prev < Math.ceil(slots.length / limit) ? prev + 1 : prev
              )
            }
            disabled={pageNo >= Math.ceil(slots.length / limit)}
          >
            Next
          </button>
        </div>
      </div>
      {/* Delete Confirmation Modal */}
      <CustomModal
        show={showDeleteConfirm}
        title="Confirm Deletion"
        message="Are you sure you want to delete this Group?"
        onConfirm={async () => {
          try {
            setLoading(true);
            const response = await AuthInterceptor(
              `/admin/slot-group/${confirmDeleteId}`,
              {
                method: "DELETE",
              }
            );
            const data = response.data;
            if (data.s === 200) {
              setSlots((prev) =>
                prev.filter((slot) => slot._id !== confirmDeleteId)
              );
              setSnack({
                notification: {
                  message: "Slot deleted successfully",
                  type: "success",
                },
              });
            }
          } catch (err) {
            console.error("Error deleting slot:", err);
            setSnack({
              notification: { message: "Error deleting slot", type: "error" },
            });
          } finally {
            setLoading(false);
            setShowDeleteConfirm(false);
            setConfirmDeleteId(null);
          }
        }}
        onCancel={() => {
          setShowDeleteConfirm(false);
          setConfirmDeleteId(null);
        }}
      />

      {/*Add Slots Modal */}
      <Modal show={addSlots} onHide={() => setAddSlots(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Slot</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleAddSlot}>
            <div className="mb-3">
              <label className="form-label">Group Name</label>
              <input
                type="text"
                className="form-control"
                value={addGroupName}
                onChange={(e) => setAddGroupName(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Group Type</label>
              <input
                type="text"
                className="form-control"
                value={addGroupType}
                onChange={(e) => setAddGroupType(e.target.value)}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? <Spinnerr show={loading} /> : "Add Slot"}
            </button>
          </form>
        </Modal.Body>
      </Modal>

      {/* Edit Slot Modal */}
      <Modal show={editModel} onHide={() => setEditModel(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleEditSlot}>
            <div className="mb-3">
              <label className="form-label">Group Name</label>
              <input
                type="text"
                className="form-control"
                value={editGroupName}
                onChange={(e) => setEditGroupName(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Group Type</label>
              <input
                type="text"
                className="form-control"
                value={editGroupType}
                onChange={(e) => setEditGroupType(e.target.value)}
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? <Spinnerr show={loading} /> : "Update Slot"}
            </button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GroupsList;
